import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import axios from "axios";


const ReelsComponent = () => {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchReels = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/list-reels`);
        setReels(response.data.reels);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch reels");
      } finally {
        setLoading(false);
      }
    };

    fetchReels();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[534px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-[534px]">
        <div className="text-red-500 text-center">
          {error}
          <button
            onClick={() => window.location.reload()}
            className="ml-2 px-4 py-2 bg-[#D4AF37] text-white rounded-md hover:bg-[#C9A227]"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (reels.length === 0) {
    return (
      <div className="flex justify-center items-center h-[534px]">
        <div className="text-gray-500">No reels found</div>
      </div>
    );
  }

  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={24}
      slidesPerView={1}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      loop={true}
      breakpoints={{
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      }}
      className="w-full"
    >
      {reels.map((reel) => (
        <SwiperSlide key={reel.id} className="flex justify-center">
          <div className="relative w-[300px] h-[534px] rounded-lg overflow-hidden shadow-lg border-2 border-[#D4AF37]/50 hover:border-[#D4AF37] transition-all duration-300">
            <video
              src={reel.video}
              className="w-full h-full object-cover"
              muted
              loop
              playsInline
              autoPlay
            >
              Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <p className="absolute bottom-4 left-4 text-white text-sm font-medium">
              {reel.title}
            </p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ReelsComponent;
